<script type="text/ecmascript-6">

    import {mapGetters} from "vuex";

    export default {
        props: {
            name: {
                require: true
            }
        },

        /**
         * Computed these properties.
         */
        computed: {
            ...mapGetters({
                dateTime: 'getDateTime',
                ownPage: 'getOwnPage',
            })
        },
    }
</script>

<template>
    <div class="row">
        <div class="col-md-3">
            <div class="d-flex flex-row rounded">
                <div class="p-0">
                    <img :src="ownPage.picture" width="50" alt="" class="rounded-circle">
                </div>
                <div class="pl-3 pt-2 pr-2 pb-2 w-75">
                    <h5 class="text-black">{{ ownPage.name }}</h5>
                    <h6 class="text-black">@{{ ownPage.username }}</h6>
                </div>
            </div>
        </div>
        <div class="col-md-9 px-3 float-right">
            <div class="pt-2 pr-2 pb-2 text-right">
                <h5 class="text-black">{{ name }}</h5>
                <h6 class="text-black">{{ moment(dateTime.startDate).format('DD MMM YYYY')}} - {{ moment(dateTime.endDate).format('DD MMM YYYY')}}</h6>
            </div>
        </div>
    </div>
</template>
